import { action } from 'src/store/common';

export const ActionTypes = {
  GET_LOCALE: '[LOCALE]GET_LOCALE',
  SET_LOCALE: '[LOCALE]SET_LOCALE',
};

export const Actions = {
  getAppLocale: action(ActionTypes.GET_LOCALE),
  setLocale: action(ActionTypes.SET_LOCALE),
};
